<template>
    <div class="floatLayer" v-show="show" :class="{ 'notice':infotype == 'notice'}">
        <!-- 通知形式 -->
        <template v-if="infotype == 'notice'">
            <div class="ad-header">
                <span class="ad-title">{{info.title}}：</span>
                <a
                    class="close-btn"
                    href="javascript:;"
                    @click.stop="closeView"
                >×</a>
            </div>
            <div class="ad-content" v-html="info.infocontent"></div>
        </template>
        <!-- 纯图片形式 -->
        <div v-if="infotype == 'ad'" class="ad-img">
            <img :src="info.linkimg" @click="jump"/>
            <a
                class="close-btn-ad"
                href="javascript:;"
                @click.stop="closeView"
            >×</a>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            object: [],
            left: 0,
            top: 0,
            interval: 50,
            distance: 1,
            directionX: 1,
            directionY: 1,
            zIndex: 100,
            target: '_blank',
            cursor: 'pointer',
            i: 0,

            info: {},
            show: false,

            infotype: '',//0 通知类型   1 纯图片形式
        };
    },
    props: ['json'],
    mounted() {
        this.init(this.json);
        // 新闻通知
        this.$get(`${this.$store.state.api.webUrl}/index/information/getwebinfounion.json`, {
            featurecode: this.$siteConfig.planName,
            categoryids: "370",
            featureonly: 1
        }, data => {
            if(data.length > 0){
                this.show = true;
                this.info= data[0];
                this.infotype = 'notice';
            }else{
                // 图片形式【广告管理】
                this.$get(`${this.$store.state.api.webUrl}/index/information/getwebadmsgunion.json`, {
                    featurecode: this.$siteConfig.planName,
                    categoryids: "110",
                    featureonly: 1,
                    maxrow: 1,
                }, data => {
                    if(data && data.adguid){
                        this.show = true;
                        this.info= data;
                        this.infotype = 'ad';
                    }else{
                        this.show = false;
                    }
                });
            }
        })
    },
    methods: {
        jump(){
            if(!this.info.linkurl){
                return
            }
            window.open(this.info.linkurl)
        },
        closeView() {
            this.$emit('closeView');
        },
        init(json) {
            var obj = document.querySelector('.floatLayer');
            //自定义
            obj.left = parseInt(json.left || this.left);
            obj.top = parseInt(json.top || this.top);
            obj.interval = json.interval || this.interval;
            obj.distance = json.distance || this.distance;
            obj.directionX = json.directionX || this.directionX;
            obj.directionY = json.directionY || this.directionY;
            obj.index = this.object.length;
            obj.url = json.url;
            obj.target = json.target || this.target;
            obj.t = null;
            //事件
            if (obj.url != undefined) {
                obj.onclick = function () {
                    switch (this.target) {
                        case '_blank':
                            open(this.url);
                            break;
                        case '_parent':
                            parent.location = this.url;
                        case '_top':
                            top.location = this.url;
                            break;
                        case '_self':
                            location = this.url;
                            break;
                    }
                };
            }
            if (!json.noHoverPause) {
                obj.onmouseover = function () {
                    clearInterval(this.t);
                };
                obj.onmouseout = function () {
                    obj.t = setInterval(function () {
                        that.float(obj.index);
                    }, obj.interval);
                };
            }
            obj.src = json.src;
            obj.style.cursor = json.cursor || this.cursor;
            obj.style.position = 'absolute';
            obj.style.left = obj.left + 'px';
            obj.style.top = obj.top + 'px';
            obj.style.zIndex = json.zIndex || this.zIndex;
            obj.style.width = json.width || '';
            obj.style.height = json.height || '';
            obj.style.directionX = json.directionX || this.directionX;
            obj.style.directionY = json.directionY || this.directionY;
            this.object.push(obj);
            //console.log(this.object)
            document.body.appendChild(obj);
            let that = this;
            console.log(obj.t);
            obj.t = setInterval(function () {
                that.float(obj.index);
            }, obj.interval);
        },
        float(index) {
            //console.log("dd",index);
            var pageWidth = document.documentElement.clientWidth;
            var pageHeight = document.documentElement.clientHeight;
            var scrollLeft = document.documentElement.scrollLeft;
            var scrollTop = document.documentElement.scrollTop;

            var obj = this.object[index];
            //console.log("s",obj)

            obj.left = obj.left + obj.directionX * obj.distance;
            if (obj.left <= scrollLeft) {
                obj.left = scrollLeft;
                obj.directionX = 1;
            }
            if (obj.left + obj.offsetWidth >= pageWidth + scrollLeft - 1) {
                obj.left = pageWidth + scrollLeft - 1 - obj.offsetWidth;
                obj.directionX = -1;
            }

            obj.top = obj.top + obj.directionY * obj.distance;
            if (obj.top <= scrollTop) {
                obj.top = scrollTop;
                obj.directionY = 1;
            }
            if (obj.top + obj.offsetHeight >= pageHeight + scrollTop - 1) {
                obj.top = pageHeight + scrollTop - 1 - obj.offsetHeight;
                obj.directionY = -1;
            }

            obj.style.left = obj.left + 'px';
            obj.style.top = obj.top + 'px';
        },
    },
};
</script>
<style lang="scss" scoped>
.floatLayer {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 100;
    overflow: auto;
    color: #333;
    padding: 0;
    text-align: left;
    font-size: 14px;
    z-index: 999;
}

.notice{
    background: #fff;
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.15);
    padding: 20px;
    width: 400px;
    border-radius: 8px;
}

.ad-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 15px;
    background: #3863e9;
    border-bottom: 1px solid #ebeef5;

    .ad-title {
        font-weight: 600;
        color: #fff;
        font-size: 15px;
    }
}

.ad-content {
    padding: 15px;
    line-height: 1.6;
    padding-bottom: 20px;
    letter-spacing: 0.5px;

    p {
        margin-bottom: 10px;
        &:last-child {
            margin-bottom: 0;
        }
    }

    strong {
        color: #f56c6c;
        font-weight: 600;
    }
}
.close-btn {
    display: block;
    position: absolute;
    right: 0px;
    top: 0px;
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    overflow: hidden;
    font-size: 30px;
    color: #fff;
    z-index: 110;
}

.ad-img{
    position: relative;
    .close-btn-ad{
        display: block;
        position: absolute;
        right: 0px;
        top: 0px;
        width: 40px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        overflow: hidden;
        font-size: 30px;
        color: #252323;
        z-index: 110;
    }
}


</style>